import Container from "react-bootstrap/Container";
import { Row, Col } from "react-bootstrap";

export default function LandingHeader({
  title,
  subtitle,
  landingcontent,
  calculator,
}) {
  return (
    <Container className="px-1 hero mx-md-auto">
      <Row className="align-items-start g-4 g-lg-5">
        <Col md={7} className="order-2 order-md-1">
          <h1 className="title">{title}</h1>

          {subtitle && <p className="subtitle">{subtitle}</p>}

          {landingcontent}
        </Col>

        <Col md={5} className="order-1 order-md-2">
          {calculator}
        </Col>
      </Row>
    </Container>
  );
}
